exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folder-tags {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.folder-tags .tag {\n  padding: 3px 8px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  background: rgba(34, 89, 161, 0.1);\n  color: #2259A1;\n  font-weight: bold;\n  border-radius: 15px;\n  overflow-wrap: anywhere;\n}\n", ""]);

// exports
